import classNames from 'classnames';
import {map} from 'lodash';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';
import {fetchMatchesIfNeeded} from '../../../../../actions/app/onSite/matches/listWidget';
import {ChampionshipSelector} from '../../../../../components/ChampionshipSelector';
import Loader from '../../../../../components/Loader';
import selectEntities from '../../../../../selectors/entities';
import {getNextGameWeekByChampiomshipId} from '../../../../Tools/Tds/Widgets/TdsList';
import './MatchesListWidget.css';

const initialState = {championship: 1, day: ''};
class MatchesListWidget extends React.Component {
  constructor(props) {
    super(props);

    const state = initialState;
    if (props.championship) state.championship = props.championship;

    this.state = state;
  }

  fetchMatchesList = day => {
    const {championship} = this.state;
    if (day || this.state.day) {
      this.props.dispatch(
        fetchMatchesIfNeeded({
          championship,
          day: typeof day === 'string' ? day : this.state.day,
        }),
      );
    } else {
      this.props.dispatch(
        getNextGameWeekByChampiomshipId({
          championshipId: this.state.championship,
          onSuccess: response =>
            this.props.dispatch(
              fetchMatchesIfNeeded({
                championship,
                day: response.gameWeek.gameWeekNumber - 1,
              }),
            ),
        }),
      );
    }
  };

  displayRequestMessage(info = this.props.widget.info) {
    if (info.error) {
      switch (info.error) {
        default:
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong with: "${info.lastAction}"<br/>` +
              `<pre><code>${JSON.stringify(info, undefined, 4)}</code></pre>`,
          });
      }
    }
  }

  changeChampionship(championship) {
    this.setState({championship});
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: `?championship=${championship}`,
    });
  }

  componentDidMount() {
    this.fetchMatchesList();
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.championship !== this.state.championship)
      this.fetchMatchesList();
  }

  componentWillReceiveProps(nextProps) {
    const {info} = this.props.widget;
    const nextInfo = nextProps.widget.info;

    if (info.success !== nextInfo.success || info.error !== nextInfo.error)
      this.displayRequestMessage(nextInfo);

    this.setState({day: nextProps.widget.day});
  }

  renderNoResult() {
    return (
      !this.props.widget.info.isFetching && (
        <div className="no-result text-center">
          <h4 className="text-red">
            <i className="fa fa-meh-o" /> Oh! we couldn't find any matches
            corresponding to your request.
          </h4>
        </div>
      )
    );
  }

  renderBody() {
    const {championship} = this.state;
    const {entities} = this.props.matches;
    if (entities.length < 1) return this.renderNoResult();
    return (
      <table className="table table-responsive table-striped table-hover">
        <thead>
          <tr>
            <th className="text-left" colSpan={2}>
              <i className="fa fa-home" /> Home
            </th>
            <th className="text-center">Score</th>
            <th className="text-right" colSpan={2}>
              <i className="fa fa-plane" /> Away
            </th>
          </tr>
        </thead>
        <tbody>
          {map(entities, (entity, key) => {
            return (
              <tr
                key={key}
                id={entity.id}
                className="match"
                onClick={() => {
                  return (
                    (entity.home.score !== null ||
                      entity.home.score !== undefined) &&
                    parseInt(championship, 10) === 1 &&
                    this.props.history.push(`/matches/read/${entity.id}`)
                  );
                }}
                style={{
                  cursor:
                    (entity.home.score !== null ||
                      entity.home.score !== undefined) &&
                    parseInt(championship, 10) === 1
                      ? 'pointer'
                      : 'default',
                }}>
                {/* Home brand */}
                <td className="text-left">
                  <img
                    style={{width: 50, height: 50}}
                    src={entity.home.jerseyUrl}
                    alt=""
                  />
                </td>

                {/* Home club */}
                <td
                  className={classNames('text-right', {
                    'text-bold': entity.home.score > entity.away.score,
                  })}
                  width="30%">
                  {entity.home.clubName}
                </td>

                {/* Score */}
                <td className="score text-center">
                  {entity.home.score}&nbsp;-&nbsp;{entity.away.score}
                </td>

                {/* Away club */}
                <td
                  className={classNames('text-left', {
                    'text-bold': entity.home.score < entity.away.score,
                  })}
                  width="30%">
                  {entity.away.clubName}
                </td>

                {/* Away brand */}
                <td className="text-right">
                  <img
                    style={{width: 50, height: 50}}
                    src={entity.away.jerseyUrl}
                    alt=""
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  render() {
    const {info} = this.props.widget;
    const {championship} = this.state;
    const renderSelectOptions = () => {
      let options = [];
      for (let i = 1; i <= 38 || 0; i++) {
        options.push(
          <option key={i} value={i}>
            {numeral(i).format('0o')} day
          </option>,
        );
      }

      return options;
    };
    return (
      <div id="matches-list-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-th-list" /> Matches list
              </h3>
              <div className="box-tools pull-right">
                <ChampionshipSelector
                  championship={championship}
                  onChange={c => this.changeChampionship(c)}
                  onRefresh={this.fetchMatchesList}
                />
                <form className="form-inline">
                  <select
                    className="form-control"
                    value={parseInt(this.state.day, 10)}
                    onChange={e => {
                      this.setState({day: e.target.value});
                      this.fetchMatchesList(e.target.value);
                    }}
                    disabled={this.props.widget.info.isFetching}>
                    <option value="">Last day</option>
                    {renderSelectOptions()}
                  </select>
                </form>
              </div>
            </div>
            <div className="box-body">{this.renderBody()}</div>
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

MatchesListWidget.propTypes = {
  championship: PropTypes.number,
};

export default withRouter(
  connect(
    state => {
      const {matches} = state.entities;
      const widget = state.app.onSite.matches.listWidget;

      return {widget, matches: {entities: selectEntities(matches, widget.ids)}};
    },
    dispatch => ({dispatch}),
  )(MatchesListWidget),
);



// WEBPACK FOOTER //
// ./src/pages/OnSite/Matches/Widgets/MatchesList/index.js